// Frontend configuration for different environments
const config = {
  development: {
    API_BASE_URL: process.env.REACT_APP_AI_URL_DEV,
    AUTH_BASE_URL: process.env.REACT_APP_BASE_URL_DEV,
    PYTHON_API_URL: process.env.REACT_APP_PYTHON_API_URL_DEV,
    GOOGLE_AUTH_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    FRONTEND_URL: process.env.REACT_APP_FE_URL_DEV,
    PAYSTACK_ID: process.env.REACT_APP_PAYSTACK_KEY_DEV,
    DEBUG_PAYMENT_PROVIDER: process.env.REACT_APP_DEBUG_PAYMENT_PROVIDER,
  },
  production: {
    API_BASE_URL: process.env.REACT_APP_AI_URL_PROD,
    AUTH_BASE_URL: process.env.REACT_APP_BASE_URL_PROD,
    PYTHON_API_URL: process.env.REACT_APP_PYTHON_API_URL_PROD,
    GOOGLE_AUTH_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    FRONTEND_URL: process.env.REACT_APP_FE_URL_PROD,
    PAYSTACK_ID: process.env.REACT_APP_PAYSTACK_KEY_PROD,
    DEBUG_PAYMENT_PROVIDER: process.env.REACT_APP_DEBUG_PAYMENT_PROVIDER,
  },
};

// Detect environment
const environment =
  process.env.NODE_ENV === "production" ? "production" : "development";

export const API_BASE_URL =
  config[environment]?.API_BASE_URL || config.development.API_BASE_URL;
export const AUTH_BASE_URL =
  config[environment]?.AUTH_BASE_URL || config.development.AUTH_BASE_URL;
export const FRONTEND_URL =
  config[environment]?.FRONTEND_URL || config.development.FRONTEND_URL;
export const GOOGLE_AUTH_CLIENT_ID =
  config[environment]?.GOOGLE_AUTH_CLIENT_ID ||
  config.development.GOOGLE_AUTH_CLIENT_ID;
export const PAYSTACK_ID =
  config[environment]?.PAYSTACK_ID || config.development.PAYSTACK_ID;
export const DEBUG_PAYMENT_PROVIDER =
  config[environment]?.DEBUG_PAYMENT_PROVIDER ||
  config.development.DEBUG_PAYMENT_PROVIDER;
export const PYTHON_API_URL =
  config[environment]?.PYTHON_API_URL || config.development.PYTHON_API_URL;
export const OLD_URL = process.env.REACT_APP_OLD_URL;
export const EMAIL="support@dockie.ai"

// WebSocket URL for activity tracking
export const ACTIVITY_WS_URL = 'wss://api-dev.dockie.ai/api/v1/activity/ws';

export default {
  API_BASE_URL,
  AUTH_BASE_URL,
  PYTHON_API_URL,
  FRONTEND_URL,
  GOOGLE_AUTH_CLIENT_ID,
  environment,
  PAYSTACK_ID,
  DEBUG_PAYMENT_PROVIDER,
  OLD_URL,
  ACTIVITY_WS_URL,
  EMAIL
}; 